"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _attachAudioPresenterSources = require("@studio/sources/attachAudioPresenterSources");
var _getSourcesInProgram = require("@studio/sources/getSourcesInProgram");
var _sceneBuilder = require("@studio/program/sceneBuilder/sceneBuilder");
var _types = require("./types");
var _sendToDatadogWithIds = require("../../utils/sendToDatadogWithIds");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Since we have different setProgram for lite and pro
 * then the setProgram action will have to be passed in as an argument.
 *
 * @param presenterId This set a featured presenter.
 * @param setProgram set program action r
 * @returns {(function(*, *, *): void)|*}
 */
function setFeaturedPresenter(presenterId, setProgram) {
  return function (dispatch, getState) {
    var _getState = getState(),
      banners = _getState.banners,
      sceneLayout = _getState.sceneLayout,
      sceneLayers = _getState.sceneLayers,
      attendeeMuteStatus = _getState.attendeeMuteStatus,
      layers = _getState.program.layers,
      brandingSettings = _getState.brandingSettings;
    var combinedLayers = [].concat(_toConsumableArray(sceneLayers), _toConsumableArray(banners));
    var sources = layers.map(function (_ref) {
      var source = _ref.source,
        _id = _ref._id;
      return _objectSpread(_objectSpread({}, source), {}, {
        featured: _id === presenterId
      });
    });
    var withAudioPresenterSources = (0, _attachAudioPresenterSources.attachAudioPresenterSources)(sources, attendeeMuteStatus);
    var scene = (0, _sceneBuilder.sceneBuilder)(sceneLayout, withAudioPresenterSources, combinedLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);

    // add presenterId on the payload object so that it's available on
    // notifyDirectors middleware
    var action = {
      type: _types.BROADCAST_SET_FEATURED_PRESENTER,
      payload: {
        presenterId: presenterId
      }
    };
    var isLiveSource = (0, _getSourcesInProgram.isSourceInProgram)(layers, presenterId);
    dispatch(action);
    if (isLiveSource) {
      dispatch(setProgram(scene));
      (0, _sendToDatadogWithIds.logProgramChange)(getState, 'setFeaturedPresenter action');
    }
  };
}
var _default = exports["default"] = setFeaturedPresenter;